import React from 'react';
import PropTypes from 'prop-types';
import { defineMessage, FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import ProductFeatureList from './ProductFeatureList';


function ProductListChequingDetails({ chequingAccount, ...otherProps }) {
    const items = createItems(chequingAccount);

    return (
        <StyledProductFeatureList
            items={items}
            {...otherProps}
        />
    );
}

ProductListChequingDetails.propTypes = {
    chequingAccount: PropTypes.shape({
        monthlyFee: PropTypes.number.isRequired,
        transactionFee: PropTypes.number.isRequired,
        eTransferFee: PropTypes.number.isRequired,
    }).isRequired,
};

const StyledProductFeatureList = styled(ProductFeatureList)`
    max-width: 27em;
`;


function createItems(chequingAccount) {
    return [
        {
            term: (
                <FormattedMessage
                    id="web-components.chequing.monthly-fee"
                    defaultMessage="Monthly fee"
                />
            ),
            definition: (
                <b>
                    <FormattedNumber
                        value={chequingAccount.monthlyFee}
                        format="CAD2"
                    />
                </b>
            ),
        },
        {
            term: (
                <FormattedMessage
                    id="web-components.chequing.transaction-fees"
                    defaultMessage="Transaction fees"
                />
            ),
            definition: (
                <>
                    <b>
                        <FormattedNumber
                            value={chequingAccount.transactionFee}
                            format="CAD2"
                        />
                    </b>
                    <FormattedMessage
                        {...PER_USE_MESSAGE}
                    />
                </>
            ),
        },
        {
            term: (
                <FormattedMessage
                    id="web-components.chequing.e-transfer-fees"
                    defaultMessage="Interac e-transfer"
                />
            ),
            definition: (
                <>
                    <b>
                        <FormattedNumber
                            value={chequingAccount.eTransferFee}
                            format="CAD2"
                        />
                    </b>
                    <FormattedMessage
                        {...PER_USE_MESSAGE}
                    />
                </>
            ),
        },
    ];
}


const PER_USE_MESSAGE = defineMessage({
    id: 'web-components.edb.chequing.per-use',
    defaultMessage: ' per use',
});


export default ProductListChequingDetails;
